export const deviceReady = (callback?: () => void) => {
  if ((window as any).cordova !== undefined) {
    document.addEventListener(
      'deviceready',
      () => {
        callback?.();
      },
      false,
    );
  } else {
    callback?.();
  }
};
